import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { createQuery, IQuery, PaginatedResults } from '@utils';
import { first, pluck } from 'rxjs/operators';

import { API_URL } from '../../core.tokens';
import { Plan, PlanStep } from '../../models/plan.model';

@Injectable()
export class PlanCoreService {

  constructor(
    protected http: HttpClient,
    @Inject(API_URL) protected apiUrl: string
  ) { }


  getByQuery(query: IQuery) {
    return this.http.post<PaginatedResults<Plan>>(`${this.apiUrl}/plan/query`, query).pipe(first());
  }

  getById(id: number) {
    return this.http.get<Plan>(`${this.apiUrl}/plan/${id}`).pipe(first());
  }

  getByName(name?: string) {
    let q;
    if (name) {
      q = createQuery({
        filter: {
          logic: 'and',
          filters: [
            { field: 'name', op: 'contains', value: name }
          ]
        },
        size: 1000
      });
    } else {
      q = createQuery({ size: 1000 });
    }
    return this.getByQuery(q).pipe(
      pluck('results')
    );
  }

  getByProcedureIdAndName(procedureId: number, name?: string) {
    return this.http.get<Plan[]>(
      `${this.apiUrl}/plan/by-procedure-id-and-name?procedureId=${procedureId}${name ? '&name=' + name : ''}`
    ).pipe(first());
  }

  getStepByPlanIdAndName(planId: number, name?: string) {
    return this.http.get<PlanStep[]>(
      `${this.apiUrl}/plan-step/by-plan-id-and-name?planId=${planId}${name ? '&name=' + name : ''}`
    ).pipe(first());
  }

}
